import { useMutation } from "react-query";
import { updateAgreement } from "../../../../actions/CarrierAgreementMgmt/Agreements";
const useEditAgreement = () => {
  return useMutation(updateAgreement);
};
export default useEditAgreement;
